import { useGetCommonParams } from '../hooks';
import { useGetScreensInfiniteQuery } from './hooks/useGetScreensInfiniteQuery';
import { useGetScreensMetaQuery } from './hooks/useGetScreensMetaQuery';

/**
 * tab surface 등 lazy mount 환경에서 화면 데이터를 mount 시점부터 미리 fetch하기 위한 컴포넌트.
 * UI를 그리지 않고 useQuery만 호출하므로, 같은 queryKey의 useQuery가 나중에 mount되면
 * cache hit으로 즉시 데이터를 사용할 수 있습니다.
 *
 * `useGetScreensInfiniteQuery`는 staleTime/gcTime=0 설정이라 observer가 0이 되는 순간
 * cache가 GC됨에 유의하세요. 이 컴포넌트가 살아있는 동안엔 observer count ≥ 1이 보장됩니다.
 */
export const ScreensPrefetcher = () => {
  const { nextToken } = useGetCommonParams();
  useGetScreensInfiniteQuery(nextToken);
  useGetScreensMetaQuery();
  return null;
};
